import React from 'react';

import { convertDate } from '../../../Helpers/helpers';

import { Grid, Typography, TextField } from '@mui/material';
import { ticketTypoTitle } from '../../shared/commonStyle';

import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

const InstallTicketTransport = (props) => {
  const transporter = props.transporter;
  const date_scheduled = props.date_scheduled;

  const onCustomerInfoChange = props.onCustomerInfoChange;

  const handleChange = (key, value) => {
    switch (key) {
      case 'transporter':
        onCustomerInfoChange(key, value);
        break;
      case 'date_scheduled':
        {
          let year = value['$y'].toString();
          let month = (value['$M'] + 1).toString().padStart(2, '0');
          let day = value['$D'].toString().padStart(2, '0');
          let hours = value['$H'].toString().padStart(2, '0');
          let minutes = value['$m'].toString().padStart(2, '0');

          const date = `${year}/${month}/${day} ${hours}:${minutes}`;
          onCustomerInfoChange(key, date);
        }
        break;

      default:
        break;
    }
  };

  return (
    <Grid
      container
      // justifyContent='space-between'
      // alignItems='center'
      flexDirection={{ xs: 'column', sm: 'row' }}
      sx={{ fontSize: '12px' }}
      xs={12}
      md={12}
      lg={12}
      spacing={0}
      rowGap={1}
    >
      <Grid
        container
        xs={12}
        md={12}
        flexDirection='row'
        rowGap={1}
        columnGap={1}
        alignContent='flex-start'
      >
        <Grid item xs={12} lg={4}>
          <Typography style={ticketTypoTitle}>Transporter:</Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField
            id='transporter'
            size='small'
            sx={{
              width: '100%',
              background: '#ffffff',
              padding: 0,
            }}
            required
            defaultValue={transporter}
            onChange={(event) =>
              handleChange(event.target.id, event.target.value)
            }
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <Typography style={ticketTypoTitle}>Date Scheduled:</Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
              inputFormat='DD/MM/YYYY HH:mm'
              sx={{ background: '#fff' }}
              size='small'
              value={date_scheduled ?? null}
              onChange={(val) => {
                handleChange('date_scheduled', dayjs(val));
              }}
              renderInput={(props) => (
                <TextField
                  {...props}
                  sx={{ background: '#fff' }}
                  fullWidth
                  size='small'
                />
              )}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default InstallTicketTransport;
